import jwtDecode from 'jwt-decode';
import { JwtTokenInfo } from '../models/general.models';
import dayjs from 'dayjs';

export default function isTokenExpired(accessToken: string) {
  const tokenInfo = jwtDecode<JwtTokenInfo>(accessToken);
  const expirationDate = dayjs(tokenInfo.exp * 1000);
  const isExpired = expirationDate.isBefore(dayjs());
  return isExpired;
}

export function shouldRefreshToken(
  accessToken: string,
  bufferSeconds: number = 60
): boolean {
  const tokenInfo = jwtDecode<JwtTokenInfo>(accessToken);
  const expirationDate = dayjs(tokenInfo.exp * 1000);
  const now = dayjs();

  // Token considerato da refreshare se scade entro il buffer di tempo (default 1 minuto)
  const timeUntilExpiry = expirationDate.diff(now, 'seconds');
  const shouldRefresh = timeUntilExpiry <= bufferSeconds;

  return shouldRefresh;
}
